if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading__spinner').classList.remove('hidden');

  const productUrl = opener.getAttribute('data-product-url');
  const fetchUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=quick-add-form`;

  fetch(fetchUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const formElement = responseHTML.querySelector('.quick-add-form-wrapper');

      HTMLUpdateUtility.setInnerHTML(this.modalContent, formElement.outerHTML);
      initQuickAddVariantSync(this.modalContent);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      super.show(opener);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading__spinner').classList.add('hidden');
    });
}

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}



function initQuickAddVariantSync(container) {
  const variantSelects = container.querySelector('variant-selects');
  if (!variantSelects) return;

  const variantDataEl = container.querySelector('[data-all-variants]');
  if (!variantDataEl) return;

  const variants = JSON.parse(variantDataEl.textContent);
  const form = container.querySelector('[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  if (!variantInput) return;

  // iOS Safari: position:fixed + overflow:auto 컨테이너 안에서 label click이 불안정 →
  // cursor:pointer가 있는 variant_button_box에 touchend+click 이중 처리
  container.querySelectorAll('.product-form__input--pill .variant_button_box').forEach((box) => {
    let touchStartX = 0, touchStartY = 0, touchHandled = false;

    function activateBox() {
      const input = box.querySelector('input[type="radio"]');
      if (!input || input.classList.contains('disabled')) return;

      const inputGroup = box.closest('.product-form__input');
      if (!inputGroup) return;

      inputGroup.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = false;
        radio.closest('.variant_button_box')?.classList.remove('is-selected');
      });
      input.checked = true;
      box.classList.add('is-selected');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    box.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchHandled = false;
    }, { passive: true });

    box.addEventListener('touchend', function (e) {
      const dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
      const dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dx > 10 || dy > 10) return;
      e.preventDefault();
      touchHandled = true;
      activateBox();
    });

    box.addEventListener('click', function (e) {
      e.preventDefault();
      if (touchHandled) { touchHandled = false; return; }
      activateBox();
    });
  });

  variantSelects.addEventListener('change', (event) => {
    const target = event.target;

    if (target.tagName === 'INPUT' && target.type === 'radio') {
      const inputGroup = target.closest('.product-form__input');
      if (inputGroup) {
        inputGroup.querySelectorAll('[data-selected-value]').forEach((el) => {
          el.innerHTML = target.value;
        });
        inputGroup.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.closest('.variant_button_box')?.classList.toggle('is-selected', radio === target);
        });
      }
    }

    const selectedOptions = [];
    variantSelects.querySelectorAll('.product-form__input').forEach((inputGroup) => {
      const select = inputGroup.querySelector('select');
      if (select) {
        selectedOptions.push(select.value);
      } else {
        const checked = inputGroup.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value);
      }
    });

    const matchingVariant = variants.find(
      (v) =>
        v.options.length === selectedOptions.length &&
        v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (!matchingVariant) return;

    variantInput.value = matchingVariant.id;
    variantInput.disabled = !matchingVariant.available;

    const submitBtn = form.closest('product-form')?.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.toggleAttribute('disabled', !matchingVariant.available);
    }
  });

  // 최초 로드 시 이미 checked된 옵션에 is-selected 클래스 초기화
  variantSelects.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
    radio.closest('.variant_button_box')?.classList.add('is-selected');
  });
}

function closeInlineQuickAdd(container, btn) {
  // 모바일에서 body로 이동했던 경우 원위치 복구
  if (container._originalParent) {
    container._originalParent.insertBefore(container, container._originalNextSibling || null);
    delete container._originalParent;
    delete container._originalNextSibling;
  }

  container.hidden = true;
  container.style.display = '';
  container.innerHTML = '';
  btn.setAttribute('aria-expanded', 'false');
  btn.closest('.card-wrapper')?.classList.remove('quick-add-open');
  document.querySelector('.inline-quick-add-overlay')?.remove();
}

document.addEventListener('click', (e) => {
  // 오버레이 클릭 시 닫기
  if (e.target.closest('.inline-quick-add-overlay')) {
    const openBtn = document.querySelector('[data-inline-quick-add][aria-expanded="true"]');
    if (!openBtn) return;
    const openContainer = document.getElementById(openBtn.getAttribute('data-target'));
    if (openContainer) closeInlineQuickAdd(openContainer, openBtn);
    return;
  }

  const btn = e.target.closest('[data-inline-quick-add]');
  if (!btn) return;

  const targetId = btn.getAttribute('data-target');
  const container = document.getElementById(targetId);
  if (!container) return;

  // 이미 열려있으면 닫기
  if (!container.hidden) {
    closeInlineQuickAdd(container, btn);
    return;
  }

  // 다른 패널이 열려있으면 먼저 닫기
  const openBtn = document.querySelector('[data-inline-quick-add][aria-expanded="true"]');
  if (openBtn) {
    const openContainer = document.getElementById(openBtn.getAttribute('data-target'));
    if (openContainer) closeInlineQuickAdd(openContainer, openBtn);
  }

  btn.setAttribute('aria-disabled', 'true');
  btn.classList.add('loading');
  btn.querySelector('.loading__spinner')?.classList.remove('hidden');

  const productUrl = btn.getAttribute('data-product-url');
  const fetchUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=quick-add-form`;

  fetch(fetchUrl)
    .then((res) => res.text())
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const form = doc.querySelector('.quick-add-form-wrapper');
      container.innerHTML = form.outerHTML;
      initQuickAddVariantSync(container);

      const isMobile = window.innerWidth <= 989;

      if (isMobile) {
        // transform 부모에 갇히지 않도록 body로 이동
        container._originalParent = container.parentNode;
        container._originalNextSibling = container.nextSibling;
        document.body.appendChild(container);

        // body 이동 시 variant-selects의 connectedCallback이 재실행되어
        // updateSelectionMetadata가 중복 호출됨 → 같은 이벤트에 대한 두 번째 호출 차단
        const vs = container.querySelector('variant-selects');
        if (vs && typeof vs.updateSelectionMetadata === 'function') {
          const _orig = vs.updateSelectionMetadata.bind(vs);
          vs.updateSelectionMetadata = function (evt) {
            if (vs._lastHandledEvt === evt) return;
            vs._lastHandledEvt = evt;
            _orig(evt);
          };
        }
      }

      container.hidden = false;
      container.style.display = 'block';
      btn.setAttribute('aria-expanded', 'true');
      btn.closest('.card-wrapper')?.classList.add('quick-add-open');

      // 딤 오버레이 생성 (모바일: body에, 데스크탑: card__inner에)
      if (!document.querySelector('.inline-quick-add-overlay')) {
        const overlay = document.createElement('div');
        overlay.className = 'inline-quick-add-overlay';
        if (isMobile) {
          document.body.appendChild(overlay);
        } else {
          container.closest('.card__inner')?.appendChild(overlay);
        }
      }

      if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
    })
    .finally(() => {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      btn.querySelector('.loading__spinner')?.classList.add('hidden');
    });
});
